export const getModule = (state, id) => state.module.modules.entries[id];
